module.exports = __webpack_public_path__ + "static/media/medications-on.587cee80.svg";